/**
 * Maximum lengths for client personal-data fields, mirroring the `Client.Max*Length` constants in
 * the backend (SONeu.Domain/Clients/Client.cs). Referenced by every form that writes these columns —
 * the internal client creation dialog, the internal master-data personal-data editor and the shared
 * asset-inventory personal-data view — so input caps and Yup validation stay in sync with each other
 * and with the backend column limits.
 *
 * Most address field lengths (house number, PLZ, city) are shared across every address form — see
 * `AddressFieldMaxLength` in `../address-fields/AddressFields.constants`. Street and country are the
 * exception: the client columns were widened for the legacy SUL import while `Court` kept 30, so the
 * client caps live here and are passed into `AddressFields` explicitly.
 *
 * Salutation is intentionally absent: it is a pure (non-freeSolo) dropdown field, so its cap comes
 * from the dropdown category instead — see `DropdownCategoryMaxLength`, which stays in the internal
 * app because dropdown administration is internal-only.
 */
export const ClientPersonalDataMaxLength = {
  comment: 255, // Client.MaxCommentLength
  title: 20, // Client.MaxTitleLength
  firstName: 25, // Client.MaxFirstNameLength
  lastName: 30, // Client.MaxLastNameLength
  formerLastName: 30, // Client.MaxFormerLastNameLength
  contactSource: 30, // Client.MaxContactSourceLength
  placeOfBirth: 50, // Client.MaxPlaceOfBirthLength — free text; the Land list is only a typing aid
  street: 80, // Client.MaxStreetLength — wider than the shared AddressFieldMaxLength.street
  country: 100, // Client.MaxCountryLength — wider than the shared AddressFieldMaxLength.country
  contactDetail: {
    value: 50, // Client.MaxContactDetailValueLength
    comment: 250, // Client.MaxContactDetailCommentLength
  },
};
